import { VStack } from "native-base";
import React from "react";
import { FlatList } from "react-native";

import CartFloatingButton from "@/components/atoms/CartFloatingButton";
import MobileHeader from "@/components/molecules/MobileHeader";
import Container from "@/components/organisms/Container";
import ProductSectionList from "@/components/organisms/ProductSectionList";
import ProductSectionListLoading from "@/components/organisms/ProductSectionList/ProductSectionListLoading";
import { useViewport } from "@/contexts/ViewportContext";

import { StoreHallListScreenProps } from "./types";

const StoreHallListMobile = ({
  store,
  hallProductsList,
  hallList,
  isLoading,
  isLoadingMore,
  onLoadMore,
  onSelectHall,
  onSelectProduct,
  onGoBack,
  onPressSearch,
}: StoreHallListScreenProps) => {
  const { height } = useViewport();
  return (
    <>
      <Container
        px="1"
        pt="2"
        Header={
          <MobileHeader
            title={store?.nome_fantasia}
            subtitle="Corredores"
            badgeList={hallList}
            showLogo={false}
            showSearch={true}
            onBackPress={onGoBack}
            onSelectBadge={(hall) => onSelectHall(hall._id)}
            onPressSearch={onPressSearch}
          />
        }>
        <VStack w="100%" h={height + "px"}>
          {isLoading && (
            <ProductSectionListLoading
              showDivider={false}
              shadow="none"
              p={0}
              my="1"
              rounded="none"
            />
          )}
          <FlatList
            data={hallProductsList}
            nestedScrollEnabled
            keyExtractor={(item, index) => (item ? item._id : index.toString())}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={{
              paddingBottom: 96,
            }}
            renderItem={({ item: hall }) => (
              <ProductSectionList
                shadow="none"
                p={0}
                my="1"
                rounded="none"
                title={hall.nome}
                data={hall.produtos}
                isLoading={isLoading}
                showDivider={false}
                onSelect={onSelectProduct}
                onPressViewMore={() => onSelectHall(hall._id)}
              />
            )}
            ListFooterComponent={
              <>
                {isLoadingMore && (
                  <ProductSectionListLoading
                    showDivider={false}
                    rows={1}
                    shadow="none"
                    p={0}
                    my="1"
                    rounded="none"
                  />
                )}
              </>
            }
            onEndReachedThreshold={0.2}
            onEndReached={onLoadMore}
          />
        </VStack>
      </Container>
      <CartFloatingButton />
    </>
  );
};

export default StoreHallListMobile;
